const defaultLayout = {
	global: {},
	layout: {
		type: 'row',
		children: [{
			type: 'tabset',
			weight: 3,
			children: [{
				type: 'tab',
				name: 'Request Builder',
				component: 'Request'
			}, {
				type: 'tab',
				name: 'Raw Request',
				component: 'RequestRaw'
			}, {
				type: 'tab',
				name: 'Token',
				component: 'Token'
			}]
		}, {
			type: 'row',
			weight: 4,
			children: [{
				type: 'row',
				weight: 1,
				children: [{
					type: 'tabset',
					weight: 1,
					children: [{
						type: 'tab',
						name: 'Requests',
						component: 'RequestsList'
					}]
				},]
			}, {
				type: 'row',
				weight: 1,
				children: [{
					type: 'tabset',
					weight: 1,
					children: [{
						type: 'tab',
						name: 'Notifications',
						component: 'NotificationsList'
					}]
				}]
			}]
		}, {
			type: 'tabset',
			weight: 5,
			children: [{
				type: 'tab',
				name: 'Details',
				component: 'Details'
			}]
		}]
	}
};

export default defaultLayout;